<div>
  <h1>Access denied</h1>
  <p>You have no access to this company.</p>
  <a a-button class="btn_primary" [href]="accountServiceUrl">Browse my companies</a>
</div>
